<mat-card style="border-color: #5775a8;">
  <mat-card-header class="flex flex-col rounded-lg w-full">
    <div class="flex flex-row rounded-lg w-full " style="align-items: flex-end;">
      <div class="flex flex-row w-full">
        <span style="font-size: x-large;color: #5775a8;">
          Business View
        </span>
      </div>
      <div class="flex flex-row w-full justify-end">
        <button mat-raised-button (click)="complaintView()" class="m-8" style="background-color: #5775a8;">
          <mat-icon style="color: white;">open_in_new</mat-icon>
          <span style="color: white;"> Go to Complaint View </span>
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="flex flex-col rounded-lg w-full">
    <br />
    <mat-card class="flex flex-col rounded-lg w-full">
      <div class="flex flex-col items-center w-full">
        <business-businessInfo class="w-full" [parentPanel]=1></business-businessInfo>
      </div>
    </mat-card>

    <mat-card>

      <mat-tab-group dynamicHeight [(selectedIndex)]="currentTab" (selectedTabChange)="tab()">

        <mat-tab label="Complaints ({{complaintCount}})">
          <business-businessComplaintList [businessId]="businessId"></business-businessComplaintList>
        </mat-tab>

        <mat-tab label="Comments ({{commentCount}})">
          <business-businessComments [businessId]="businessId" [parentPanel]="1"></business-businessComments>
        </mat-tab>

        <mat-tab label="Correspondence">
          <shared-sharedCorrespondence [parentPanel]="1"></shared-sharedCorrespondence>
        </mat-tab>

        <mat-tab label="Site Visit">
          <shared-sharedSiteVisit [parentPanel]="1"></shared-sharedSiteVisit>
        </mat-tab>

        <mat-tab label="Enclosed Area">
          <shared-sharedEnclosedArea [parentPanel]="1"></shared-sharedEnclosedArea>
        </mat-tab>

        <mat-tab label="Citations">
          <shared-sharedCitations [parentPanel]="1"></shared-sharedCitations>
        </mat-tab>

        <mat-tab label="Annual Inspections" *ngIf="showInspection">
          <inspections></inspections>
        </mat-tab>
      </mat-tab-group>

    </mat-card>
    <br />

  </mat-card-content>

</mat-card>